import { useEffect, useState } from 'react';
import { Kites } from '../services/Store';

export default function useKites() {
    const [kites, setKites] = useState(Kites.get());

    useEffect(() => {
        const subscription = Kites.stateChanged.subscribe(({ kites }) => {
            setKites({ ...kites });
        });
        return () => subscription.unsubscribe();
    }, [setKites, Kites]);

    return {
        count: Object.keys(kites).length,
        kites,
        select: (id) => Kites.selectKite(id),
        add: (template, variation) => Kites.addKite(template, variation),
        remove: (id) => Kites.removeKite(id),
        previous: () => Kites.previousKite(),
        next: () => Kites.nextKite(),
        importKites: (kites) => Kites.importKites(kites),
    };
}
